import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import useDelaySession from './useDelaySession';

function RefreshSession() {
  const delaySession = useDelaySession();
  const location = useLocation();
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      delaySession();
    } else {
      didMountRef.current = true;
    }
  }, [delaySession, location.pathname]);
  return null;
}

export default RefreshSession;
